module.exports = __webpack_public_path__ + "assets/img/undraw_authentication_fsn5.f09cdcf1.png";